import { useTranslation } from 'react-i18next';

import { TripArrayFieldAddressInput } from './TripArrayFieldAddressInput';

export function DropoffAddressField({ index }: { index: number }) {
  const { t } = useTranslation('common');
  return (
    <TripArrayFieldAddressInput
      index={index}
      tripField="dropoffAddress"
      label={t('reservation.dropoffAddress')}
      required
    />
  );
}

